import * as fileApi from '@/api/file';
import useFileStore from '@/utils/fileStore';
import { fetchUserPermissions } from '@/utils/permissionsService';
import { InboxOutlined } from '@ant-design/icons';
import { App, Button, Space, Typography, Upload } from 'antd';
import type { UploadFile } from 'antd/es/upload/interface';
import React from 'react';
import { useTranslation } from 'react-i18next';
import DemoButton from './demoButton';
import { openDeniedDialog } from './deniedDialog';
import CreateFileDialog from './createFileDialog';
import { useTourStore } from '@/utils/tour';
const { Title } = Typography;
type EditorTabsPlaceholderProps = {
    // onStart: () => void;
}

const { Dragger } = Upload;

const EditorTabsPlaceholder: React.FC<EditorTabsPlaceholderProps> = ({ }: EditorTabsPlaceholderProps) => {
    const { message } = App.useApp();
    const { t } = useTranslation('common');
    // const createTempFile = useFileStore(state => state.createTempFile);
    const openFile = useFileStore(state => state.openFile);
    const openInJSMOL = useFileStore(state => state.openInJSMOL);
    const updateFolder = useFileStore(state => state.updateFolder);
    const openInKetcher = useFileStore(state => state.openInKetcher);
const defaultDirFor = useFileStore(state => state.baseHome);

    const {
        openTour,
    } = useTourStore()

    const [newFileVisible, setNewFileVisible] = React.useState(false);

    

    // Handle file upload
    const handleFileUpload = async (file: File) => {
        try {
            // Upload file using the existing API
            const uploadFile: UploadFile = {
                uid: file.name,
                name: file.name,
                originFileObj: file as any, // Type casting to avoid TypeScript issues
                status: 'done'
            };

            if (!defaultDirFor) {
                return
            }

            const result = await fileApi.uploadFileResource([uploadFile], defaultDirFor, false);

            if (result?.ok) {
                message.success(t('editor_tabs_placeholder.upload_success'));

                // Get the uploaded file path
                const filePath = `${defaultDirFor}/${file.name}`;

                // Check if it's an xyz file
                const isXyzFile = file.name.toLowerCase().endsWith('.xyz');

                await updateFolder(defaultDirFor) // Refresh the directory to show the new file

                if (isXyzFile) {
                    // Open in JSMol for xyz files
                    await openInJSMOL(filePath);
                } else {
                    // Open in text editor for other files
                    await openFile(filePath);
                }
            } else {
                message.error(result?.message || t('editor_tabs_placeholder.upload_failed'));
            }
        } catch (error) {
            console.error('Upload error:', error);
            message.error(t('editor_tabs_placeholder.upload_failed'));
        } finally {
        }
    };

    return (
        <div className='flex flex-col items-center justify-center h-full w-full'>
            <CreateFileDialog
                visible={newFileVisible}
                type='file'
                targetPath={defaultDirFor ?? ''}
                onCancel={() => setNewFileVisible(false)}
                onSuccess={() => setNewFileVisible(false)}
            />
            <Space orientation='vertical' size='large'>
                <div className='flex flex-col items-center justify-center flex-1 px-6'>
                    {/* Upload Button */}
                    <div className='my-4'>
                        <Dragger
                            multiple
                            beforeUpload={(file) => {
                                handleFileUpload(file);
                                return false; // Prevent default upload
                            }}
                            showUploadList={false}
                            accept="*"
                        >
                            <div className=' flex flex-col items-center justify-center h-32'>
                                <p className=' mb-2'>
                                    <InboxOutlined style={{ fontSize: 32 }} />
                                </p>
                                <p className=' px-10'>{t('editor_tabs_placeholder.drop_indication')}</p>
                            </div>

                        </Dragger>
                    </div>
                    <Title level={5}>
                        <Button style={{ width: 150 }} type="primary" size='large' onClick={() => setNewFileVisible(true)} htmlType="submit">
                            {t('editor_tabs_placeholder.file_button')}
                        </Button>
                    </Title>
                    <Title level={5}>
                        <Space>
                            <Button size='large' onClick={()=>openTour("workplace")}>{t('editor_tabs_placeholder.quick_tour')}</Button>
                            <DemoButton />
                            <Button size='large' onClick={()=>openInKetcher()}>Open Molecule Editor</Button>
                        </Space>
                    </Title>
                </div>
            </Space>
        </div>
    );
};

export default EditorTabsPlaceholder;